import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/lib/auth";
import { Toaster } from "@/components/ui/sonner";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import Clients from "@/pages/Clients";
import Ventes from "@/pages/Ventes";
import Paiements from "@/pages/Paiements";
import Plaques from "@/pages/Plaques";
import AideCommercial from "@/pages/AideCommercial";
import Taches from "@/pages/Taches";
import VenteDetail from "@/pages/VenteDetail";
import VOVendus from "@/pages/VOVendus";
import Calendrier from "@/pages/Calendrier";
import Users from "@/pages/Users";
import Atelier from "@/pages/Atelier";
import Adresses from "@/pages/Adresses";
import VOAtelier from "@/pages/VOAtelier";
import VentesAnnulees from "@/pages/VentesAnnulees";
import Corbeille from "@/pages/Corbeille";
import Commandes from "@/pages/Commandes";
import Parametres from "@/pages/Parametres";
import BilanVentes from "@/pages/BilanVentes";
import "@/App.css";

function Protected({ children }) {
  const { user, authChecked } = useAuth();
  if (!authChecked) {
    return (
      <div className="min-h-screen flex items-center justify-center text-sm text-muted-foreground">
        Chargement…
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function PublicOnly({ children }) {
  const { user, authChecked } = useAuth();
  if (!authChecked) return null;
  if (user) return <Navigate to="/" replace />;
  return children;
}

function HomeRoute() {
  const { user } = useAuth();
  if (user?.role === "atelier") return <Navigate to="/atelier" replace />;
  return <Dashboard />;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<PublicOnly><Login /></PublicOnly>} />
          <Route path="/register" element={<PublicOnly><Register /></PublicOnly>} />
          <Route
            path="/"
            element={
              <Protected>
                <Layout />
              </Protected>
            }
          >
            <Route index element={<HomeRoute />} />
            <Route path="clients" element={<Clients />} />
            <Route path="ventes" element={<Ventes />} />
            <Route path="ventes/:id" element={<VenteDetail />} />
            <Route path="vo-vendus" element={<VOVendus />} />
            <Route path="bilan" element={<BilanVentes />} />
            <Route path="calendrier" element={<Calendrier />} />
            <Route path="utilisateurs" element={<Users />} />
            <Route path="atelier" element={<Atelier />} />
            <Route path="paiements" element={<Paiements />} />
            <Route path="plaques" element={<Plaques />} />
            <Route path="adresses" element={<Adresses />} />
            <Route path="vo-atelier" element={<VOAtelier />} />
            <Route path="ventes-annulees" element={<VentesAnnulees />} />
            <Route path="corbeille" element={<Corbeille />} />
            <Route path="commandes" element={<Commandes />} />
            <Route path="parametres" element={<Parametres />} />
            <Route path="aide-commercial" element={<AideCommercial />} />
            <Route path="taches" element={<Taches />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Toaster richColors position="top-right" />
      </BrowserRouter>
    </AuthProvider>
  );
}
